export interface BondsResponse {
  data: {
    getBonds: {
      items: Array<{
        name: string;
        bondDetails: {
          bondNumber: string;
          bondType: string;
          suretyNumber: string;
        };
      }>;
    };
  };
}

export interface DeclarantsResponse {
  data: {
    getDeclarants: {
      items: Array<{
        identifier: string;
        name: string;
        address: {
          addressLine1: string;
          zipCode: string;
          city: string;
          region: string;
          country: {
            code: string;
            label: string;
          };
        };
        isBroker: boolean;
      }>;
    };
  };
}

export interface ImportersResponse {
  data: {
    getImportersOfRecord: {
      items: Array<{
        identifier: string;
        name: string;
        address: {
          addressLine1: string;
          zipCode: string;
          city: string;
          region: string;
          country: {
            code: string;
            label: string;
          };
        };
      }>;
    };
  };
}

export type TableUISettings = {
  columnVisibility?: Record<string, boolean>;
  columnOrder?: string[];
  pageSize?: number;
};

export type UISettings = {
  // tables?: Record<string, TableUISettings>;
  exceptionsColumnVisibility?: Record<string, boolean>;
  exceptionsColumnOrder?: string[];
  exceptionsPageSize?: number;

  equipmentVehiclesColumnVisibility?: Record<string, boolean>;
  equipmentVehiclesColumnOrder?: string[];
  equipmentVehiclesPageSize?: number;
  
  consignmentsBannerDismissed?: string | boolean | null;
};

export const DEFAULT_UI_SETTINGS: UISettings = {
  consignmentsBannerDismissed: "false",
  // Add other default settings here as needed
};